const ProcesosMenu = () => null;

export default ProcesosMenu;
